import React, { useState, useEffect } from "react";
import "./Contact_Information.css";
import phone_icon from "../../assets/phone_icon.svg";
import email_icon from "../../assets/email_icon.svg";
import location_icon from "../../assets/location_icon.svg";
import Youtube from "../../assets/Youtube.svg";
import Instagram from "../../assets/Instagram.svg";
import LinkedIn from "../../assets/LinkedIn.svg";
import Facebook from "../../assets/Facebook.svg";
import X from "../../assets/X.svg";
import Cross from "../../assets/Cross.svg";
import Mic from "../../assets/Mic.svg";
import axios from "axios";
import Reload_Icon1 from "../../assets/Reload_Icon1.svg";
import Loader_Gif from "../../assets/Loader_GIF.gif";

const Contact_Information = () => {
  const [firstnameError, setFirstnameError] = useState("");
  const [lastnameError, setLastnameError] = useState("");
  const [numberError, setNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [formValues, setFormValues] = useState({
    Firstname: "",
    Lastname: "",
    Number: "",
    Email: "",
    Message: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  // const [popupMessage, setPopupMessage] = useState("");
  const [captchaNum1, setCaptchaNum1] = useState(0);
  const [captchaNum2, setCaptchaNum2] = useState(0);
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaNum1(num1);
    setCaptchaNum2(num2);
    setCaptchaAnswer("");
  };

  const handleCaptchaChange = (event) => {
    setCaptchaAnswer(event.target.value);
  };

  const isFormValid = () => {
    const isFirstnameValid =
      formValues.Firstname.trim().length >= 3 &&
      /^[A-Za-z\s]+$/.test(formValues.Firstname);

    const isNumberValid = /^[0-9]{10}$/.test(formValues.Number.trim());

    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      formValues.Email.trim(),
    );

    const isCaptchaValid =
      parseInt(captchaAnswer, 10) === captchaNum1 + captchaNum2;

    return isFirstnameValid && isNumberValid && isEmailValid && isCaptchaValid;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError("Email is required");
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "Firstname") {
      const nameRegex = /^[A-Za-z\s]*$/;
      if (nameRegex.test(value.trim())) {
        setFormValues({ ...formValues, [name]: value });
        setFirstnameError("");
      } else {
        setFirstnameError("Please enter correct name");
      }
    }
    if (name === "Lastname") {
      const nameRegex = /^[A-Za-z\s]*$/;
      if (nameRegex.test(value.trim())) {
        setFormValues({ ...formValues, [name]: value });
        setLastnameError("");
      } else {
        setLastnameError("Please enter correct name");
      }
    }
    if (name === "Number") {
      const onlyDigits = value.replace(/\D/g, "");
      setFormValues({ ...formValues, [name]: onlyDigits });
      if (onlyDigits.length < 10) {
        setNumberError("Number should be 10 digits");
      } else {
        setNumberError("");
      }
    }
    if (name === "Email") {
      validateEmail(value);
      setFormValues({ ...formValues, [name]: value });
    }
    if (name === "Message") {
      setFormValues({ ...formValues, [name]: value }); // update always
      if (value.trim() === "") {
        setMessageError("Please enter a message");
      } else {
        setMessageError("");
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // validation checks...
    const nameRegex = /^[A-Za-z\s]+$/;
    if (formValues.Firstname.trim() === "") {
      setFirstnameError("Please enter your Name.");
      return;
    } else if (!nameRegex.test(formValues.Firstname)) {
      setFirstnameError("Name should only contain letters.");
      return;
    } else if (formValues.Firstname.trim().length < 3) {
      setFirstnameError("Name should be at least 3 characters.");
      return;
    }
    // Lastname validation (optional)
    // if (formValues.Lastname.trim() === "") {
    //   setLastnameError("Please enter your last name.");
    //   return;
    // } else if (!nameRegex.test(formValues.Lastname)) {
    //   setLastnameError("Last name should only contain letters.");
    //   return;
    // } else if (formValues.Lastname.trim().length < 3) {
    //   setLastnameError("Last name should be at least 3 characters.");
    //   return;
    // }
    const numberRegex = /^[0-9]\d{9}$/;
    if (formValues.Number.trim() === "") {
      setNumberError("Please enter your mobile number.");
      return;
    } else if (!numberRegex.test(formValues.Number)) {
      setNumberError("Please enter a valid 10-digit number.");
      return;
    } else {
      setNumberError("");
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formValues.Email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    // if (formValues.Message.trim() === "") {
    //   setMessageError("Please enter a message.");
    //   return;
    // } else {
    //   setMessageError("");
    // }

    if (parseInt(captchaAnswer, 10) !== captchaNum1 + captchaNum2) {
      alert("Captcha verification failed. Please try again.");
      generateCaptcha();
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "http://192.168.0.162/Boloindia_Project/controllers/AboutUs_Form.php",
        // "https://boloindia.com/Boloindia_Project/controllers/AboutUs_Form.php",
        formValues,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // ✅ success
      setShowPopup(true);
      setFormValues({
        Firstname: "",
        Lastname: "",
        Number: "",
        Email: "",
        Message: "",
      });
      setEmailError(""); // clear old error
      generateCaptcha();
    } catch (err) {
      if (err.response && err.response.status === 409) {
        // ✅ duplicate email case
        setEmailError("This email is already registered.");
      } else if (err.response && err.response.data?.error) {
        setEmailError(err.response.data.error);
      } else {
        console.error("Error submitting form:", err);
        setEmailError("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleReloadCaptcha = () => {
    generateCaptcha();
  };

  return (
    <div>
      <div className="Main_Form_Details">
        <div className="Form_Details">
          <div className="Left_Card">
            <div className="card-blob blob11"></div>
            <div className="card-blob blob12"></div>
            <div className="card-blob blob13"></div>

            <h3>Contact Information</h3>
            <div className="Contact">
              <div className="Phone_Call">
                <a href="tel:+91 80 23230607">
                  <img src={phone_icon} alt="phone_icon" />
                </a>
                <p>
                  <a href="tel:+91 80 23230607">+91 80 23232383</a>
                </p>
              </div>
              <div className="Email">
                <a href="mailto:namaste@boloindia.com">
                  <img src={email_icon} alt="email_icon" />
                </a>
                <p>
                  <a href="mailto:namaste@boloindia.com">
                    namaste@boloindia.com
                  </a>
                </p>
              </div>
              <div className="Location">
                <a
                  href="https://maps.app.goo.gl/AP2kiBDRPbGHs5FRA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={location_icon} alt="location_icon" />
                </a>
                <p>
                  <a
                    href="https://maps.app.goo.gl/AP2kiBDRPbGHs5FRA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    No.122, C Wing, 3rd Main Rd, 2nd Stage, Gruha Lakshmi
                    Layout, Basaweshwara Nagar, Bengaluru, Karnataka 560079
                  </a>
                </p>
              </div>
            </div>
            <h3 className="Follow">Follow us on</h3>
            <div className="Icons">
              {/* <a
                href="https://www.youtube.com/@BoloIndiaMediaNetworks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Youtube} alt="Youtube" />
              </a> */}
              <a
                href="https://www.instagram.com/boloindia.medianetworks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Instagram} alt="Instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/bolo-india-media-networks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LinkedIn} alt="LinkedIn" />
              </a>
              <a
                href="https://www.facebook.com/people/Bolo-India-Media-Networks/61587577619520/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Facebook} alt="Facebook" />
              </a>
              <a
                href="https://x.com/boloindiamedia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={X} alt="X" />
              </a>
            </div>
          </div>

          <div className="Right_Form">
            <form className="Each_Right_Field">
              <div className="Right_Form_Fields">
                <div className="First_Line_Fields">
                  <div className="Contact_Field">
                    <input
                      type="text"
                      name="Firstname"
                      value={formValues.Firstname}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label>
                      First Name <span>*</span>
                    </label>
                    <div className="Error_msg">
                      {firstnameError && <p>{firstnameError}</p>}
                    </div>
                  </div>
                  <div className="Contact_Field">
                    <input
                      type="text"
                      name="Lastname"
                      value={formValues.Lastname}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label>Last Name</label>
                    <div className="Error_msg">
                      {lastnameError && <p>{lastnameError}</p>}
                    </div>
                  </div>
                </div>
                <div className="Second_Line_Fields">
                  <div className="Contact_Field">
                    <input
                      type="text"
                      name="Number"
                      value={formValues.Number}
                      onChange={handleChange}
                      placeholder=" "
                      maxLength={10}
                    />
                    <label>
                      Mobile Number <span>*</span>
                    </label>
                    <div className="Error_msg">
                      {numberError && <p>{numberError}</p>}
                    </div>
                  </div>
                  <div className="Contact_Field">
                    <input
                      type="email"
                      name="Email"
                      value={formValues.Email}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label>
                      E-mail <span>*</span>
                    </label>
                    <div className="Error_msg">
                      {emailError && <p>{emailError}</p>}
                    </div>
                  </div>
                </div>
                <div className="Third_Line_Field">
                  <div className="Contact_Field">
                    <textarea
                      name="Message"
                      value={formValues.Message}
                      onChange={handleChange}
                      placeholder=" "
                    ></textarea>
                    <label>Message</label>
                    <div className="Error_msgs">
                      {messageError && <p>{messageError}</p>}
                    </div>
                  </div>
                </div>

                <div className="Captcha_Form">
                  <div className="Captcha_Block1">
                    <div className="numbers1">
                      {captchaNum1} <label>+</label> {captchaNum2}{" "}
                      <label>=</label>
                    </div>
                    <input
                      className="Input_Field_Form"
                      type="text"
                      value={captchaAnswer}
                      onChange={handleCaptchaChange}
                      aria-label="Enter the result of the captcha"
                    />
                    <img
                      className="Reload"
                      src={Reload_Icon1}
                      onClick={handleReloadCaptcha}
                      alt="Reload"
                    />
                  </div>
                </div>

                <div className="Submit_Button">
                  <button
                    type="submit"
                    id="Click_For_Contact"
                    onClick={handleSubmit}
                    disabled={!isFormValid()}
                  >
                    Submit
                  </button>
                </div>
              </div>

              {/* Mobile Screen */}
              <div className="Right_Form_Fields1">
                <div className="Form_Fields_Data">
                  <div className="Contact_Field1">
                    <input
                      type="text"
                      name="Firstname"
                      value={formValues.Firstname}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label>
                      First Name <span>*</span>
                    </label>
                    <div className="Error_msg1">
                      {firstnameError && <p>{firstnameError}</p>}
                    </div>
                  </div>
                  <div className="Contact_Field1">
                    <input
                      type="text"
                      name="Lastname"
                      value={formValues.Lastname}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label>Last Name</label>
                    <div className="Error_msg1">
                      {lastnameError && <p>{lastnameError}</p>}
                    </div>
                  </div>
                  <div className="Contact_Field1">
                    <input
                      type="text"
                      name="Number"
                      value={formValues.Number}
                      onChange={handleChange}
                      placeholder=" "
                      maxLength={10}
                    />
                    <label>
                      Mobile Number <span>*</span>
                    </label>
                    <div className="Error_msg1">
                      {numberError && <p>{numberError}</p>}
                    </div>
                  </div>
                  <div className="Contact_Field1">
                    <input
                      type="email"
                      name="Email"
                      value={formValues.Email}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label>
                      E-mail <span>*</span>
                    </label>
                    <div className="Error_msg1">
                      {emailError && <p>{emailError}</p>}
                    </div>
                  </div>
                  <div className="Contact_Field1">
                    <textarea
                      name="Message"
                      value={formValues.Message}
                      onChange={handleChange}
                      placeholder=" "
                    ></textarea>
                    <label>Message</label>
                    <div className="Error_msgs1">
                      {messageError && <p>{messageError}</p>}
                    </div>
                  </div>

                  <div className="Captcha_Form">
                    <div className="Captcha_Block1">
                      <div className="numbers1">
                        {captchaNum1} <label>+</label> {captchaNum2}{" "}
                        <label>=</label>
                      </div>
                      <input
                        className="Input_Field_Form"
                        type="text"
                        value={captchaAnswer}
                        onChange={handleCaptchaChange}
                        aria-label="Enter the result of the captcha"
                      />
                      <img
                        className="Reload"
                        src={Reload_Icon1}
                        onClick={handleReloadCaptcha}
                        alt="Reload"
                      />
                    </div>
                  </div>

                  <div className="Submit_Button1">
                    <button
                      type="submit"
                      id="Click_For_Contact"
                      onClick={handleSubmit}
                      disabled={!isFormValid()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* ✅ Popup Modal */}
        {showPopup && (
          <div className="Display">
            <div className="Title">
              <img
                src={Cross}
                alt="cross"
                className="Close_btn"
                onClick={() => {
                  setShowPopup(false);
                  setFormValues({
                    Firstname: "",
                    Lastname: "",
                    Number: "",
                    Email: "",
                    Message: "",
                  });
                }}
              />
              <img src={Mic} alt="mic" />
              <h2>Thank you!</h2>
              <p>We will get back to you soon.</p>
              {/* <p>{popupMessage}</p>
            <button onClick={() => setShowPopup(false)}>Close</button> */}
            </div>
          </div>
        )}

        {loading && (
          <div className="Loader_Overlay">
            <img src={Loader_Gif} alt="Loading..." className="Loader_Image" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Contact_Information;
